import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const pet_health_v2_consent = (params: StepConfigParams) =>
  ({
    // content handled in app
    subFlow: params.subFlow,
    nextStep: 'pet_health_v2_purchase',
  }) as const satisfies AnyStepConfiguration

export default pet_health_v2_consent
